module.exports = __webpack_public_path__ + "img/kefuvx_01.6761e3cb.png";